import { Box, Flex, Grid, GridItem, Image, Input, Select, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from "@chakra-ui/react";
import MyDiv from "./score.style";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { AlertCard, CustomButton, CustomToast, ActionEditIcon, CustomTable } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { IScore } from "./model";
import { Column } from "../../../../components/CustomTable/customTable";

const Header = [
  { id: 1, head: "S. No" },
  { id: 4, head: "Score" },
  { id: 6, head: "Status" },
  { id: 7, head: "Actions" },
];

const Score = () => {
  const [scores, setScores] = useState<IScore[]>([]);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentScore, setCurrentScore] = useState({ id: 0, score: "", status: true, });
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [statusChangeSource, setStatusChangeSource] = useState<"table" | "drawer" | null>(null);

  useEffect(() => {
    loadScores();
  }, []);

  const loadScores = async () => {
    const response = await fetchApi<IScore[]>("Hrlense_Score", "GET");
    if (response) setScores(response);
  };

  const handleStatusChange = (id: number, newStatus: boolean) => {
    setSelectedId(id);
    setPendingStatus(newStatus);
    setStatusChangeSource("table");
    setAlertOpen(true);
  };

  const handleDrawerStatusChange = (newStatus: boolean) => {
    setPendingStatus(newStatus);
    setStatusChangeSource("drawer");
    setAlertOpen(true);
  };

  const handleConfirmStatusChange = async () => {
    if (selectedId !== null && pendingStatus !== null) {
      const scoreId = statusChangeSource === "table" ? selectedId : currentScore.id;

      const response = await fetchApi(`Hrlense_Score/changestatus/${scoreId}`, "PUT", { Id: scoreId, Status: pendingStatus });
      if (response) {
        if (statusChangeSource === "table") {
          setScores((prev) => prev.map((score) => score.id === selectedId ? { ...score, status: pendingStatus } : score));
        } else {
          setCurrentScore((prev) => ({ ...prev, status: pendingStatus }));
        }
      }
    }
    setAlertOpen(false);
  };

  const handleAddNewScore = () => {
    setIsEditMode(false);
    setCurrentScore({ id: 0, score: "", status: true });
    setDrawerOpen(true);
  };

  const handleEditScore = (score: IScore) => {
    setIsEditMode(true);
    setSelectedId(score.id);
    setCurrentScore(score);
    setDrawerOpen(true);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setCurrentScore((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!currentScore.score.trim()) {
    addToast({ message: "Please enter Score", status: "warning" });
    return;
  }
    if (isEditMode) {
      const response = await fetchApi(`Hrlense_Score/${currentScore.id}`, "PUT", { id: currentScore.id, score: currentScore.score, status: currentScore.status, }, null, "Score updated successfully");

      if (response) setScores((prev) => prev.map((score) => (score.id === selectedId ? currentScore : score)));
    } else {
      const response = await fetchApi<IScore>("Hrlense_Score", "POST", { score: currentScore.score, status: currentScore.status, }, null, "Score added successfully");
      if (response) setScores((prev) => [...prev, response]);
    }
    setDrawerOpen(false);
  };

  const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");

  return (
    <MyDiv>
      <Box position="relative" minH="300px">
        {loading ? (
          <Center position="absolute" top={0} left={0} right={0} bottom={0}>
            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
          </Center>) : (
          <>
            <Flex className="page_heading flex_header">
              <Text className="font-poppins text_semibold text_3xl">Score</Text>
              <Flex gap={2}>
                <CustomButton title="Add New Score" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewScore} />
              </Flex>
            </Flex>
            <Grid className="grid_container">
              <GridItem colSpan={12}>
                <CustomTable value={scores}>
                  <Column header="S. No" body={(_, index) => index + 1} />
                  <Column header="Score" field="score" />
                  <Column
                    header="Status"
                    body={(row: any) => (
                      <Select
                        value={row.status ? "true" : "false"}
                        onChange={(e) => handleStatusChange(row.id, e.target.value === "true")}
                        width="120px"
                        height="32px"
                        icon={<ChevronDownIcon />}
                        borderRadius="4px"
                        color={getStatusColor(row.status)}
                        className="font-poppins text_medium text_xsm"
                      >
                        <option value="true" style={{ color: "#38A169" }}>Active</option>
                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                      </Select>
                    )}
                  />
                
                  <Column
                    header="Actions"
                    body={(row: any) => <ActionEditIcon onClick={() => handleEditScore(row)} />}
                  />
                </CustomTable>

              </GridItem>
            </Grid>

            <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />

            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader borderBottomWidth="1px">{isEditMode ? "Edit Score" : "Add New Score"}</DrawerHeader>
                <DrawerBody display="flex" flexDirection="column" justifyContent="space-between">
                  <Box py={4}>
                    <FormControl mb={4} isRequired>
                      <FormLabel>Score</FormLabel>
                      <Input name="score" value={currentScore.score} onChange={handleInputChange} placeholder="Enter Score" />
                    </FormControl>
                    <FormControl mb={4}>
                      <FormLabel>Status</FormLabel>
                      <Select w="120px" value={currentScore.status ? "true" : "false"} onChange={(e) => handleDrawerStatusChange(e.target.value === "true")} color={getStatusColor(currentScore.status)}>
                        <option value="true" style={{ color: "#38A169" }}> Active</option>
                        <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Flex justify="flex-end" mt={4} gap={2}>
                    <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}>Cancel</Button>
                    <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }} isLoading={loading} >{isEditMode ? "Update Score" : "Add Score"}</Button>
                  </Flex>
                </DrawerBody>
              </DrawerContent>
            </Drawer>
          </>)}
      </Box>
    </MyDiv>
  );
};
export default Score;
